import type { RouteRecordRaw } from 'vue-router';

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: 'settings',
    name: 'settings',
    component: () => import('./pages/SettingsHomePage.vue'),
    meta: { title: 'Settings', requiresAuth: true, permission: 'is-admin' },
  },
  {
    path: 'settings/industry-template',
    name: 'settings.industry-template',
    component: () => import('./pages/IndustryTemplatePage.vue'),
    meta: { title: 'Industry template', requiresAuth: true, permission: 'update_company_settings' },
  },
  {
    path: 'settings/industry-template/products',
    name: 'settings.industry-template.products',
    component: () => import('./pages/IndustryBuilderProductsPage.vue'),
    meta: {
      title: 'Offer builder products',
      requiresAuth: true,
      permission: 'update_company_settings',
    },
  },
  {
    path: 'settings/company',
    name: 'settings.company',
    component: () => import('./pages/CompanyPage.vue'),
    meta: { title: 'Company', requiresAuth: true, permission: 'update_company_settings' },
  },
  {
    path: 'settings/branches',
    name: 'settings.branches',
    component: () => import('./pages/BranchesPage.vue'),
    meta: { title: 'Branches', requiresAuth: true, permission: 'update_company_branches' },
  },
  {
    path: 'settings/taxes',
    name: 'settings.taxes',
    component: () => import('./pages/TaxesPage.vue'),
    meta: { title: 'Taxes', requiresAuth: true, permission: 'update_taxes' },
  },
  {
    path: 'settings/tax-rates',
    redirect: { name: 'settings.taxes' },
  },
  {
    path: 'settings/financial-accounts',
    name: 'settings.financial-accounts',
    component: () => import('./pages/FinancialAccountsPage.vue'),
    meta: {
      title: 'Financial accounts',
      requiresAuth: true,
      permission: 'update_company_settings',
    },
  },
  {
    path: 'settings/countries',
    name: 'settings.countries',
    component: () => import('./pages/CountriesPage.vue'),
    meta: { title: 'Countries', requiresAuth: true, permission: 'update_countries' },
  },
  {
    path: 'settings/currencies',
    name: 'settings.currencies',
    component: () => import('./pages/CurrenciesPage.vue'),
    meta: { title: 'Currencies', requiresAuth: true, permission: 'update_currencies' },
  },
  {
    path: 'settings/users',
    name: 'settings.users',
    component: () => import('./pages/UsersPage.vue'),
    meta: { title: 'Users', requiresAuth: true, permission: 'view_users' },
  },
  {
    // Assigning permissions to a user is permission administration → administrator-only.
    path: 'settings/users/:id/permissions',
    name: 'settings.users.permissions',
    component: () => import('./pages/UserPermissionsPage.vue'),
    meta: { title: 'User permissions', requiresAuth: true, permission: 'update_permissions' },
  },
  {
    // Role administration → administrator-only.
    path: 'settings/roles',
    name: 'settings.roles',
    component: () => import('./pages/RolesPage.vue'),
    meta: { title: 'Roles', requiresAuth: true, permission: 'view_roles' },
  },
  {
    path: 'settings/appearance',
    name: 'settings.appearance',
    component: () => import('./pages/AppearancePage.vue'),
    meta: { title: 'Appearance', requiresAuth: true },
  },
  {
    path: 'settings/date-format',
    name: 'settings.date-format',
    component: () => import('./pages/DateFormatPage.vue'),
    meta: { title: 'Date & format', requiresAuth: true },
  },
  {
    path: 'settings/fiscal-key',
    name: 'settings.fiscal-key',
    component: () => import('./pages/FiscalKeyPage.vue'),
    meta: { title: 'Fiscal key', requiresAuth: true, permission: 'view_fiscal_keys' },
  },
  {
    path: 'settings/printers',
    name: 'settings.printers',
    component: () => import('./pages/PrintersPage.vue'),
    meta: { title: 'Printers', requiresAuth: true, permission: 'update_company_settings' },
  },
  {
    path: 'settings/receipt-layout',
    name: 'settings.receipt-layout',
    component: () => import('./pages/ReceiptLayoutPage.vue'),
    meta: { title: 'Receipt layout', requiresAuth: true, permission: 'update_company_settings' },
  },
  {
    path: 'settings/advanced',
    name: 'settings.advanced',
    component: () => import('./pages/AdvancedPage.vue'),
    meta: { title: 'Advanced', requiresAuth: true, permission: 'is-admin' },
  },
  {
    path: 'settings/sales',
    name: 'settings.sales',
    component: () => import('./pages/SalesSettingsPage.vue'),
    meta: {
      title: 'Sales notifications',
      requiresAuth: true,
      permission: 'update_company_settings',
    },
  },
  {
    path: 'settings/ai-scans',
    name: 'settings.ai-scans',
    component: () => import('./pages/AiScansPage.vue'),
    meta: { title: 'AI Scanning', requiresAuth: true },
  },
  {
    path: 'settings/vat-book-mapping',
    name: 'settings.vat-book-mapping',
    component: () => import('./pages/VatBookMappingPage.vue'),
    meta: {
      title: 'VAT book mapping',
      requiresAuth: true,
      permission: 'manage_vat_book_mapping',
    },
  },
  {
    path: 'settings/backup',
    name: 'settings.backup',
    component: () => import('./pages/BackupPage.vue'),
    meta: {
      title: 'Backups',
      requiresAuth: true,
      permission: 'manage_backups',
    },
  },
];
